/**
 * Monate als `YYYY-MM` — die Einheit der Abrechnung (Projektstruktur.md §4).
 * Die Wahl reicht zwölf Monate zurück; älteres holt man über die Adresse.
 */

export function aktuellerMonat(): string {
  const jetzt = new Date()
  return `${jetzt.getFullYear()}-${String(jetzt.getMonth() + 1).padStart(2, '0')}`
}

export function monatsauswahl(anzahl = 12): Array<{ id: string; label: string }> {
  const jetzt = new Date()
  const liste: Array<{ id: string; label: string }> = []
  for (let i = 0; i < anzahl; i += 1) {
    const d = new Date(jetzt.getFullYear(), jetzt.getMonth() - i, 1)
    const id = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
    liste.push({ id, label: monatsname(id) })
  }
  return liste
}

export function monatsname(monat: string): string {
  const [jahr, m] = monat.split('-')
  if (!jahr || !m) return monat
  return new Date(Number(jahr), Number(m) - 1, 1).toLocaleDateString('de-DE', {
    month: 'long',
    year: 'numeric',
  })
}

export function istMonat(wert: string): boolean {
  return /^\d{4}-\d{2}$/.test(wert)
}

export function euro(cent: number): string {
  return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
}

export function datum(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function zeitpunkt(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
